/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback } from 'react';

import { FaChevronDown } from 'react-icons/fa';
import { Link } from 'gatsby';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import usePostCategories from '../../graphql/staticQueries/usePostCategories';
import bgImg from '../../../assets/resources/optimized-images/header_bg.png';
import bgImgWebp from '../../../assets/resources/optimized-images/header_bg.webp';

const BlogCategories = ({ activeCategory }) => {
  const categories = usePostCategories();
  const [dropActive, setDropActive] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y !== prevPos.y) setScrollY(currPos.y);
    },
    [scrollY],
    null,
    true,
    300
  );

  const toggleDrop = useCallback(() => {
    setDropActive(val => !val);
  });

  const categoryClicked = useCallback(() => {
    setDropActive(val => !val);
  });

  const activeForDisplay =
    activeCategory === 'blog' ? 'ALL' : activeCategory.toUpperCase();

  return (
    <div className="result-index">
      <div className="navigation-beam">
        <div className="navigation-beam__bg-container">
          <picture>
            <source srcSet={bgImgWebp} type="image/webp" />
            <source srcSet={bgImg} type="image/jpeg" />
            <img src={bgImg} alt="navigation bg" />
          </picture>
        </div>
        <div className="container">
          <div className="tt-category">Select category:</div>
          <div className="nav-category">
            {categories.map(category => {
              const linkTo =
                category === 'all'
                  ? 'blog/'
                  : `blog/topic/${category
                      .replace(/\s+/g, '-')
                      .toLowerCase()}/`;

              const isActive =
                category === 'all'
                  ? activeCategory === 'blog'
                  : activeCategory === category.replace(/\s+/g, '-');

              return (
                <Link
                  to={linkTo}
                  key={category}
                  state={{ scrollY }}
                  className={`item-category ${isActive ? 'active' : ''}`}
                  onClick={() => categoryClicked(category)}
                >
                  {category.toUpperCase()}
                </Link>
              );
            })}
          </div>

          <div className="mobile-menu">
            <div className="nav-post-xs visible-xs">
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div
                className={`main-select ${dropActive ? 'active' : ''}`}
                id="show-post-menu"
                onClick={toggleDrop}
              >
                <div className="select-active">{activeForDisplay}</div>
                <div className="select-icon">
                  <FaChevronDown
                    id="drop-icon"
                    className={dropActive ? 'rotate' : ''}
                  />
                </div>
              </div>
              <div
                className={`drop-select nav nav-tabs ${
                  dropActive ? 'show' : ''
                }`}
                id="drop-select"
              >
                {categories.map(category => {
                  const linkTo =
                    category === 'all'
                      ? 'blog/'
                      : `blog/topic/${category
                          .replace(/\s+/g, '-')
                          .toLowerCase()}/`;

                  const isActive =
                    category === 'all'
                      ? activeCategory === 'blog'
                      : activeCategory === category.replace(/\s+/g, '-');

                  return (
                    <Link
                      to={linkTo}
                      key={category}
                      state={{ scrollY }}
                      className={`item-category-drop item ${
                        isActive ? 'active' : ''
                      }`}
                      onClick={() => categoryClicked(category)}
                      role="button"
                    >
                      {category.toUpperCase()}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCategories;
